import { Controller } from '@hotwired/stimulus'
import { request } from '../lib/request'

export default class extends Controller {
  static values = { url: String, enabled: Boolean }

  collectionsEnbableUpdate = () => {
    request('patch', this.urlValue, {
      body: this.params,
      responseKind: 'turbo-stream',
    })
  }

  get params() {
    return { user: { collections_enabled: this.enabledValue } }
  }
}
